import { useCallback } from 'react';
import { useDispatch } from 'store/hooks';
import {
    ConfirmAddWidgetsAction,
    lockLayout,
    unlockLayout,
    confirmAddWidgets,
    UnlockLayoutAction,
} from './actions';
import { WidgetType } from 'widgets/WidgetType';
import LayoutShape from 'layout/LayoutShape';
import { LayoutActionStateChange } from 'layout/store/actions';
import { saveLayoutShape } from 'layout/store/thunks';
import { ThunkDispatch } from 'store/store';
import { WidgetId } from 'widgets/WidgetId';
import ManagedLayout from 'layoutManagement/ManagedLayout';
import { requestAddWidgets } from './thunks';
import { AnyConfig } from 'widgets/WidgetRegistry';
import {
    createLoadWidgetConfigurationAction,
    WidgetLoadConfigAction,
} from 'widgets/store/configuration/actions';

export const useDispatchLockLayout = () => {
    const dispatch = useDispatch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useCallback(() => dispatch(lockLayout()), []);
};

export const useDispatchUnlockLayout = () => {
    const dispatch = useDispatch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useCallback(() => dispatch(unlockLayout()), []);
};

export const useDispatchRequestAddWidget = () => {
    const dispatch = useDispatch();
    return useCallback(
        (widgets: Array<{ widget: WidgetType; layout?: ManagedLayout }>) =>
            dispatch(
                requestAddWidgets(
                    widgets.map((w) => ({
                        widgetType: w.widget,
                        layout: w.layout,
                    }))
                )
            ),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );
};

export const layoutRendererDispatcher =
    () =>
    (
        dispatch: ThunkDispatch<
            | LayoutActionStateChange
            | ConfirmAddWidgetsAction
            | WidgetLoadConfigAction<AnyConfig>
            | UnlockLayoutAction
        >
    ) => ({
        saveLayoutShape: (layoutShape: LayoutShape | undefined) =>
            dispatch(saveLayoutShape(layoutShape)),
        confirmAddWidgets: (
            added: Array<{ id: WidgetId; config?: AnyConfig }>
        ) => {
            dispatch(confirmAddWidgets(added.map((a) => a.id)));
            for (const add of added) {
                if (add.config) {
                    dispatch(
                        createLoadWidgetConfigurationAction(add.id.widgetType)(
                            add.id.widgetKey,
                            add.config
                        )
                    );
                }
            }
        },
        onDraggingWidget: (added: { id: WidgetId; config?: AnyConfig }) => {
            const { id, config } = added;
            if (config) {
                dispatch(
                    createLoadWidgetConfigurationAction(id.widgetType)(
                        id.widgetKey,
                        config
                    )
                );
            }
        },
        onDraggedWidgetComplete: () => {
            dispatch(unlockLayout());
        },
    });
